var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPagination)?_c('gl-pagination',_vm._b({staticClass:"gl-mt-5",attrs:{"align":"center","value":_vm.pageInfo.page,"per-page":_vm.pageInfo.perPage,"total-items":_vm.pageInfo.total,"prev-page":_vm.pageInfo.previousPage,"next-page":_vm.pageInfo.nextPage},on:{"input":_vm.change}},'gl-pagination',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }